import React from "react";
import PageHeader from "@/components/PageHeader";

export default function TermsOfUse() {
  const lastUpdated = "1 February 2026";

  return (
    <>
      <PageHeader
        testId="terms-header"
        eyebrow="Legal"
        title="Terms of Use"
        intro="The terms that govern your use of the Evergreen Global Holdings Ltd website."
      />

      <section className="evg-section bg-white">
        <div className="evg-container max-w-4xl">
          <span
            className="text-xs uppercase tracking-[0.18em] text-[#0A1F44]/55"
            data-testid="terms-last-updated"
          >
            Last Updated: {lastUpdated}
          </span>

          <div className="mt-10 space-y-10">
            <Block title="1. Acceptance of Terms">
              By accessing or using evergreenglobalholdings.com (the “Website”), you agree to
              these Terms of Use. If you do not agree, please discontinue use of the Website.
            </Block>

            <Block title="2. Website Use">
              The Website is provided for informational purposes. You agree not to use the Website
              in any unlawful manner, to interfere with its operation, or to attempt unauthorised
              access.
            </Block>

            <Block title="3. Intellectual Property">
              All content on the Website, including text, logos, imagery, designs and trademarks,
              is the property of Evergreen Global Holdings Ltd or its licensors and is protected
              by applicable intellectual property laws.
            </Block>

            <Block title="4. Investor Information Disclaimer">
              Information on the Website is provided for discussion and informational purposes
              only and does not constitute an offer to sell or a solicitation to purchase
              securities or investment products. Any investment opportunity is subject to formal
              documentation, due diligence, regulatory requirements and applicable laws.
            </Block>

            <Block title="5. Forward-Looking Statements">
              The Website may contain forward-looking statements that involve risks and
              uncertainties. Actual outcomes may differ materially. We undertake no obligation to
              update such statements except as required by law.
            </Block>

            <Block title="6. Limitation of Liability">
              To the maximum extent permitted by law, Evergreen Global Holdings Ltd, its directors,
              officers, employees and affiliates shall not be liable for any indirect, incidental,
              consequential, special or punitive damages arising from your use of the Website.
            </Block>

            <Block title="7. Third-Party Links">
              The Website may contain links to third-party websites. Such links are provided for
              convenience only; we are not responsible for the content or practices of those sites.
            </Block>

            <Block title="8. Jurisdiction">
              These Terms of Use are governed by the laws of England and Wales. Any disputes shall
              be subject to the exclusive jurisdiction of the courts of England and Wales.
            </Block>

            <Block title="9. Changes">
              We may update these Terms of Use from time to time. Continued use of the Website
              following such updates constitutes acceptance of the revised terms.
            </Block>

            <Block title="10. Contact">
              For questions regarding these Terms of Use, please contact
              legal@evergreenglobalholdings.com.
            </Block>
          </div>
        </div>
      </section>
    </>
  );
}

function Block({ title, children }) {
  return (
    <div className="pb-8 border-b border-[#0A1F44]/10 last:border-0">
      <h2 className="font-serif text-2xl md:text-3xl leading-tight">{title}</h2>
      <p className="mt-5 evg-body">{children}</p>
    </div>
  );
}
